import { api } from './api';
import type {
  Soin,
  CreateSoinInput,
  UpdateSoinInput,
} from '../types/entities';

export const soinsService = {
  /**
   * Get all soins
   */
  async getAll(): Promise<Soin[]> {
    const response = await api.get<Soin[]>('/api/admin/soins');
    return response.data;
  },

  /**
   * Get soin by ID
   */
  async getById(id: string): Promise<Soin> {
    const response = await api.get<Soin>(`/api/admin/soins/${id}`);
    return response.data;
  },

  /**
   * Create new soin
   */
  async create(data: CreateSoinInput): Promise<Soin> {
    const response = await api.post<Soin>('/api/admin/soins', data);
    return response.data;
  },

  /**
   * Update existing soin
   */
  async update(id: string, data: UpdateSoinInput): Promise<Soin> {
    const response = await api.put<Soin>(`/api/admin/soins/${id}`, data);
    return response.data;
  },

  /**
   * Delete soin
   */
  async delete(id: string): Promise<void> {
    await api.delete(`/api/admin/soins/${id}`);
  },
};
